export function HowItWorks() {
  return (
    <section id="how-it-works" className="section">
      <div className="section-inner">
        <p className="section-label">How it works</p>
        <h2>Direct path. Nothing in the cloud.</h2>
        <p className="section-lead">
          PairBolt is free. Your files go browser → your machine over encrypted
          Turbo TCP (or WebRTC fallback) — not through our disks.
        </p>
        <div className="steps">
          <article className="step">
            <p className="step-num">01</p>
            <h3>Pair</h3>
            <p>
              Open the free receiver. It shows a short code — enter it in the
              browser sender or scan the QR.
            </p>
          </article>
          <article className="step">
            <p className="step-num">02</p>
            <h3>Select &amp; approve</h3>
            <p>
              Drop large files or whole folders. You approve the list on the
              receiver before any bytes move.
            </p>
          </article>
          <article className="step">
            <p className="step-num">03</p>
            <h3>Transfer privately</h3>
            <p>
              When your receiver is reachable, the browser uploads over parallel
              HTTPS streams (Turbo TCP on TCP 47443). Otherwise it falls back to
              a single WebRTC DataChannel. We never store, relay, or bill by
              gigabyte.
            </p>
          </article>
        </div>

        <div className="diagram" aria-label="Connection diagram">
          <span className="highlight">Browser sender</span> ──signaling / DNS / certs──▶{" "}
          <span className="highlight">pairbolt.com</span> ◀──signaling──{" "}
          <span className="highlight">Your receiver</span>
          <br />
          <span className="highlight">Browser sender</span> ════ Turbo TCP (preferred) or
          WebRTC fallback ════{" "}
          <span className="highlight">Your receiver</span>
        </div>
      </div>
    </section>
  );
}
